export default __webpack_public_path__ + "static/media/francheville29.e6ce8af0.jpg";